import { render, staticRenderFns } from "./ResidentCard.vue?vue&type=template&id=72293f4a&scoped=true&"
import script from "./ResidentCard.vue?vue&type=script&lang=js&"
export * from "./ResidentCard.vue?vue&type=script&lang=js&"
import style0 from "./ResidentCard.vue?vue&type=style&index=0&id=72293f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72293f4a",
  null
  
)

export default component.exports